import { addSizeToImageSrc } from 'shared/utils/imageUtils'

const placeholderImageUrl =
  'https://static.shop-apotheke.com/media/content/placeholder.png'
const placeholderImagePrescriptionUrl =
  'https://static.shop-apotheke.com/media/content/placeholder-prescription.png'

/**
 * @typedef ImageUrlProductArg
 * @property {string?} image
 * @property {boolean} prescriptionMedicine
 *
 * @param {object} args
 * @param {ImageUrlProductArg} args.product
 * @param {number?} args.width Desired image width
 * @param {string} args.cdnUrl - comes per tenant from the shop config
 * @returns {string}
 */
const getImageUrl = ({ product, width = null, cdnUrl }) => {
  let { image: imageUrl } = product

  if (!imageUrl) {
    imageUrl = product.prescriptionMedicine
      ? placeholderImagePrescriptionUrl
      : placeholderImageUrl
  }

  if (width === null) {
    return imageUrl
  }

  return addSizeToImageSrc({
    src: imageUrl,
    width,
    cdnUrl
  })
}

export default getImageUrl
